var _defs, _use, _clipPath, _g, _path, _linearGradient, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _linearGradient5, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutocad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "_tcPC28ZsEauYvlMQO0K_a",
    d: "M-40.802,33.105c0.496-1.331,1.264-2.903,1.318-3.001C-39.514,30.16-40.393,32.012-40.802,33.105 c-0.002,0.004-0.004,0.009-0.005,0.013C-40.806,33.114-40.804,33.109-40.802,33.105 M-27.918,9.194 c0.399,0.668,4.179,8.489,5.401,11.228c-1.203,0.611-14.25,7.538-16.969,9.686c1.304-2.373,9.918-19.954,10.494-21.032h-0.001 C-28.728,8.582-28.371,8.44-27.918,9.194 M-30.805,3c-5.163,9.304-9.634,18.93-13.411,28.878c-0.31,0.815-0.581,1.54-0.814,2.167 c-0.596,1.605-0.938,2.565-1.035,2.727l-0.139,0.511c-0.902,3.33-1.583,6.057-1.795,7.301l2.421,1.062h0.064 c0.532-1.871,2.656-7.268,3.196-8.676l0.046-0.121c0.357-0.945,0.951-2.349,1.46-3.718c6.839-2.743,13.863-4.877,21.07-6.404 c1.21,2.605,2.524,5.253,3.017,6.335c0.072,0.158,0.129,0.281,0.166,0.373c0.538,1.239,3.086,6.431,3.861,8.258 c0.602,1.42,1.133,3.088,1.339,3.763L-9,44.702c0,0-0.594-2.418-0.838-3.066c-0.1-0.266-0.434-1.523-0.932-3.389 c-0.608-1.786-1.261-3.587-1.943-5.383c-0.844-2.221-1.733-4.43-2.636-6.588c-1.007-2.406-2.031-4.749-3.033-6.967 C-21.901,11.518-25.14,5.241-26.315,3L-30.805,3L-30.805,3z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#d86666",
    overflow: "visible",
    xlinkHref: "#_tcPC28ZsEauYvlMQO0K_a"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_tcPC28ZsEauYvlMQO0K_b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#_tcPC28ZsEauYvlMQO0K_a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_tcPC28ZsEauYvlMQO0K_b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "_tcPC28ZsEauYvlMQO0K_c",
    width: 59.232,
    height: 61.221,
    x: -58.115,
    y: -6.288
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#d86666",
    overflow: "visible",
    xlinkHref: "#_tcPC28ZsEauYvlMQO0K_c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_tcPC28ZsEauYvlMQO0K_d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#_tcPC28ZsEauYvlMQO0K_c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#942d32",
    d: "M22.2,3c-5.17,9.3-9.64,18.93-13.42,28.88c-0.31,0.81-0.58,1.54-0.81,2.17 c-0.6,1.61-0.94,2.56-1.04,2.72c0.23-0.83,0.47-1.71,0.72-2.6c0.18-0.63,0.36-1.27,0.54-1.92c1.4-4.9,3.25-10.13,4.46-13.68 c1.815-4.99,3.951-9.832,6.416-14.527C19.403,3.401,20.075,3,20.801,3H22.2z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_tcPC28ZsEauYvlMQO0K_e",
    x1: 32.405,
    x2: 22.997,
    y1: 2.81,
    y2: 50.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#cb2123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752425"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_tcPC28ZsEauYvlMQO0K_e)",
    d: "M13.52,30.1c1.32-2.41,9.91-19.95,10.49-21.02 c0.13-0.25,0.29-0.41,0.47-0.41s0.38,0.15,0.6,0.52c0.4,0.67,4.18,8.49,5.4,11.23C29.28,21.03,16.26,27.94,13.52,30.1z M42.84,44.97 c0.01,0,0.01,0,0.02-0.01c0.6-0.44,0.91-1.23,0.7-2c-0.15-0.54-0.3-1.07-0.4-1.32c-0.1-0.27-0.43-1.53-0.93-3.39 c-0.61-1.79-1.26-3.59-1.94-5.39c-0.85-2.22-1.74-4.43-2.64-6.58c-1.01-2.41-2.03-4.75-3.03-6.97C31.1,11.52,27.86,5.24,26.69,3 H22.2c-5.17,9.3-9.64,18.93-13.42,28.88c-0.31,0.81-0.58,1.54-0.81,2.17c-0.6,1.6-0.94,2.56-1.04,2.72L6.8,37.28 c-0.64,2.33-1.16,4.36-1.49,5.8c-0.16,0.7,0.1,1.4,0.62,1.84c0.45,0.2,0.99,0.4,1.61,0.56c0.6-2.02,2.62-7.14,3.14-8.51l0.05-0.11 v-0.01c0.35-0.95,0.95-2.35,1.46-3.72c6.84-2.74,13.86-4.88,21.07-6.4c1.21,2.6,2.52,5.25,3.01,6.33c0.02,0.03,0.03,0.05,0.04,0.08 c0.01,0.02,0.03,0.05,0.03,0.07c0.01,0.02,0.02,0.05,0.03,0.07c0.03,0.06,0.05,0.11,0.07,0.15c0.54,1.24,3.09,6.43,3.86,8.26 c0.34,0.8,0.65,1.68,0.9,2.41c0.03,0.08,0.06,0.16,0.08,0.24c0.13,0.39,0.24,0.74,0.32,0.98c0,0.02,0.01,0.04,0.01,0.05h0.01 L42.84,44.97z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e02b2b",
    d: "M42.23,38.25c-0.61-1.79-1.26-3.59-1.94-5.39c-0.85-2.22-1.74-4.43-2.64-6.58 c-1.01-2.41-2.03-4.75-3.03-6.97C31.1,11.52,27.86,5.24,26.68,3h0.938c0.866,0,1.674,0.462,2.097,1.218 c1.768,3.162,3.316,6.428,4.645,9.812c0.53,1.28,1.23,2.84,1.81,4.57c0.78,2.31,1.96,4.92,2.72,7.52c0.67,2.31,1.31,4.61,1.88,6.71 C41.34,34.89,41.84,36.76,42.23,38.25z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_tcPC28ZsEauYvlMQO0K_f",
    x1: 21.953,
    x2: 22.463,
    y1: 26.277,
    y2: 14.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b75e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#6c272d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_tcPC28ZsEauYvlMQO0K_f)",
    d: "M30.48,20.42c-1.07,0.6-1.63,0.96-2.85,1.59 c-1.17-3.25-2.21-6.07-2.49-6.74c-0.4-0.95-1.03-0.86-1.37,0.12c-1.87,5.28-3.3,8.73-4.1,10.93c-2.64,1.46-4.24,2.62-6.15,3.79 h-0.01c1.32-2.4,9.92-20,10.5-21.03L24,9.07c0.26-0.44,0.4-0.62,0.52-0.62c0.17,0,0.28,0.33,0.56,0.74 C25.53,9.86,29.27,17.71,30.48,20.42z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_tcPC28ZsEauYvlMQO0K_g",
    x1: 30.743,
    x2: 14.914,
    y1: 30.664,
    y2: 36.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a32424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752425"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_tcPC28ZsEauYvlMQO0K_g)",
    d: "M36.28,33.06c-1.49,0.13-2.59,0.3-4.55,0.51l-0.11,0.01 c-4.03,0.45-9.01,1.1-14.72,2.06l-0.58,0.09c-1.97,0.34-3.46,0.71-5.59,1.12c0.36-0.96,0.95-2.37,1.46-3.71v-0.01 c6.8-2.85,13.83-4.99,21.07-6.4C34.47,29.33,35.78,31.98,36.28,33.06z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_tcPC28ZsEauYvlMQO0K_h",
    x1: 10.056,
    x2: 14.081,
    y1: 46.027,
    y2: 34.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#d77670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#a62224"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_tcPC28ZsEauYvlMQO0K_h)",
    d: "M16.32,35.74c-0.22,0.56-0.43,1.12-0.65,1.67 c-0.17,0.44-0.34,0.88-0.51,1.31c-0.67,1.78-1.28,3.42-1.78,4.73c-0.1,0.3-0.21,0.58-0.3,0.84c-0.18,0.47-0.33,0.88-0.46,1.22 c-1.1,0.28-2.07,0.32-2.79,0.3c-0.01,0.01-0.02,0.01-0.02,0c-0.07,0-0.15-0.01-0.22-0.01l-0.34-0.03H9.22c-0.06,0-0.12,0-0.17-0.01 c-0.01,0-0.03,0-0.04-0.01c-0.53-0.05-1.02-0.15-1.47-0.27c0.6-2.02,2.62-7.14,3.14-8.51l0.05-0.11 C12.86,36.44,14.35,36.07,16.32,35.74z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_tcPC28ZsEauYvlMQO0K_i",
    x1: 40.506,
    x2: 32.254,
    y1: 46.935,
    y2: 31.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#d77670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#a62224"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_tcPC28ZsEauYvlMQO0K_i)",
    d: "M41.62,45.37h-0.01c-0.75,0.18-1.3,0.2-2.38,0.22 c-1.31,0.04-2.08,0.05-2.91-0.18c-0.2-0.55-0.43-1.19-0.7-1.88c-0.01-0.01-0.01-0.03-0.01-0.04c-0.25-0.68-0.54-1.43-0.84-2.21 c-0.2-0.51-0.41-1.05-0.63-1.61c-0.43-1.1-0.89-2.26-1.35-3.44c-0.35-0.88-0.7-1.77-1.06-2.66c1.96-0.22,3.05-0.39,4.54-0.51h0.01 c0.02,0.05,0.05,0.11,0.06,0.15c0.01,0.02,0.02,0.05,0.03,0.07c0.03,0.06,0.05,0.11,0.07,0.15c0.54,1.24,3.09,6.43,3.86,8.26 c0.34,0.8,0.65,1.68,0.9,2.41c0.03,0.08,0.06,0.16,0.08,0.24c0.13,0.39,0.24,0.74,0.32,0.98C41.61,45.34,41.61,45.36,41.62,45.37z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a12930",
    d: "M36.3,45.41c-0.11-0.03-0.22-0.07-0.34-0.11 c-0.43-0.15-0.77-0.33-0.99-0.44l-0.01-0.01l-0.1-0.07c-0.65-0.44-1.07-1.15-1.13-1.94c-0.06-0.82-0.18-1.64-0.35-2.45 c-0.47-2.3-1.06-4.57-1.76-6.81l0.1-0.01c0.83,2.07,1.66,4.17,2.42,6.1c0.22,0.56,0.43,1.1,0.63,1.61 C35.38,42.88,35.91,44.3,36.3,45.41z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#a12930",
    d: "M16.9,35.64c-0.26,1.34-0.46,2.46-0.53,2.75c-0.11,0.44-0.2,2.45-0.25,3.9 c-0.04,0.96-0.55,1.84-1.36,2.34l-0.63,0.39c-0.29,0.12-0.61,0.24-0.94,0.34c-0.19,0.06-0.38,0.11-0.57,0.15 c0.13-0.34,0.28-0.75,0.46-1.22c0.09-0.26,0.2-0.54,0.3-0.84c0.5-1.31,1.11-2.95,1.78-4.73c0.17-0.43,0.34-0.87,0.51-1.31 c0.22-0.55,0.43-1.11,0.65-1.67L16.9,35.64z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutocad);
export default __webpack_public_path__ + "static/media/autocad.e89391cd5859bbce16bfa7b888e13920.svg";
export { ForwardRef as ReactComponent };